<template>
  <layout>
    <page-header :header="$t('start-guide.title')" />
    <div class="content">
      <b-row>
        <b-col>
          <b-card>
            <div v-html="content_html" />
          </b-card>
        </b-col>
      </b-row>
    </div>
  </layout>
</template>

<script>

const resourceBase = 'start-guide'

export default {
  name: 'StartGuide',

  components: {},

  data() {
    return {
      content_html: ''
    }
  },

  mounted () {
    this.$http.get('admin-settings/settings/?keys=guide_html').then((response) => {
      this.content_html = response.data.guide_html[this.$i18n.locale];
    })
  }
}
</script>
